var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Route } from "react-router";
import { IndexRedirect, NestedRoute } from "@irati/utils/history/routing";
import AppContainer from "@irati/ui/src/AppContainer";
import { PERKS } from "@irati-web/app/src/routeConfig";
import { LangLoader } from "@irati/utils/lang";
import { SEARCH_SECTIONS } from "../constants/search";
import SearchAll from "../containers/SearchAll/SearchAll";
import SearchAllByLocation from "../containers/SearchAllByLocation/SearchAllByLocation";
var search = /** @class */ (function (_super) {
    __extends(search, _super);
    function search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    search.prototype.render = function () {
        var path = this.props.path;
        return (React.createElement(Route, { path: path, render: function () {
                return React.createElement(AppContainer, null,
                    React.createElement(LangLoader, { bucket: PERKS },
                        React.createElement(NestedRoute, { exact: true, match: path, path: "/:page", title: "Search", component: SearchAll }),
                        React.createElement(NestedRoute, { exact: true, match: path, path: "/:page/location", title: "Search by Location", component: SearchAllByLocation }),
                        React.createElement(IndexRedirect, { match: { url: path }, to: "/" + SEARCH_SECTIONS[0] })));
            } }));
    };
    return search;
}(Component));
export default search;
